export default __webpack_public_path__ + "static/media/Union (2).d3177924.svg";